<template>
  <AddEditFolder></AddEditFolder>
</template>

<script>
import AddEditFolder from "@/layouts/components/masters/folders/addedit-folder.vue";
export default {
  components: {
    AddEditFolder,
  },
};
</script>
